import React from 'react';
import './App.css';
import history from './history';
import { Router, Switch, Route } from 'react-router-dom';


import './fonts/ibmplexmono.css';
import './fonts/twkeverett.css';

import {
    WindcaveProcessPage,
    WindcavePaymentStatusPage,
    PaymentPxPayPage,
    PaymentCardPayCodePage,
    PageNotFound,
    CSPaymentPage,
    CreateSessionPage,
    CallbackErrorPage,
    CallbackSuccessPage,
    CallbackFailurePage,
} from './views';

import Header from './views/components/navigation/header';
import Footer from './views/components/navigation/footer';

const HEALTH_INFO = {
    'status':
        {
            'applicationStatus':
            {
                'name': 'Payments UI',
                'type': 'Application',
                'status': 'GREEN',
                'statusDetails': 'OK',
            },
            'requestedDateTime': new Date(),
        },
};
function App() {
    return (
        <div className="App">
            <Header/>
            <Router history={history}>
                <Switch>
                    <Route exact path="/payment_pxpay/:paymentTokenUuid"
                        render={
                            (props) =>
                                <PaymentPxPayPage
                                    {...props}
                                />
                        } />
                    <Route exact path="/payment_pxpay/:paymentTokenUuid/pay_code"
                        render={
                            (props) =>
                                <PaymentCardPayCodePage
                                    {...props}
                                />
                        } />
                    <Route exact path="/createSession"
                        render={
                            (props) =>
                                <CreateSessionPage
                                    {...props}
                                />
                        } />
                    <Route exact path="/process_pxpay"
                        render={
                            (props) =>
                                <WindcaveProcessPage
                                    {...props}
                                />
                        } />
                    <Route exact path="/payment_pxpay_status"
                        render={
                            (props) =>
                                <WindcavePaymentStatusPage
                                    {...props}
                                />
                        } />
                    <Route exact path="/cs_process_pxpay"
                        render={
                            (props) =>
                                <CSPaymentPage
                                    {...props}
                                />
                        } />
                    <Route exact path="/callback/error" render={ () => <CallbackErrorPage/>}/>
                    <Route exact path="/callback/failure" render={ () => <CallbackFailurePage/>}/>
                    <Route exact path="/callback/success" render={ () => <CallbackSuccessPage/>}/>
                    <Route path="/private/status">
                        <p>
                            {JSON.stringify(HEALTH_INFO, null, 2) }
                        </p>
                    </Route>
                    <Route path="/">
                        <h3 style={{'padding': '120px 0'}}>Hey There!!! Welcome to CoreLogic Payment Site</h3>
                    </Route>
                    <Route component={PageNotFound} />
                </Switch>
            </Router>
            <Footer/>
        </div>
    );
}

export default App;
